import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import { Button, Modal, Form, Input, Tag, Select } from "antd";
import { BookOutlined } from "@ant-design/icons";
import { withUser } from "@unifiedpatents/sso";
import { withRouter } from "react-router";
import { createQuery, getProjects, createProject, createPortfolioByProjectId } from "../../services/api-users";

class SaveAsPortfolio extends Component {
  static propTypes = {
    filter: PropTypes.object.isRequired
  };

  state = {
    name: "Portfolio From Search",
    projectId: null,
    projectName: "",
    confirmVisible: false,
    loading: false,
    projects: []
  };

  componentDidMount() {
    this._isMounted = true;
    this._getAllProjects();
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  render() {
    const saveDisabled = !(this.props.user.status.isLoggedIn && this.props.router.location.search !== "");
    const { confirmVisible, projects, projectId, projectName, name } = this.state;
    return (
      (<Fragment>
        <Button size="small" icon={<BookOutlined />} onClick={this._showConfirm} disabled={saveDisabled} loading={this.state.loading}>
          Save As Portfolio
        </Button>
        <Modal title="Save current search as a portfolio" closable={true} open={confirmVisible} onOk={this._saveSearchAsPortfolio} onCancel={this._hideConfirm}>
          <Form layout="vertical">
            {projects.length > 0 ? (
              <Form.Item label="Project">
                <Select value={projectId} placeholder="Project" onChange={val => this.setState({ projectId: val })} getPopupContainer={trigger => trigger.parentNode}>
                  {projects.map(({ id, name }) => (
                    <Select.Option key={id} value={id}>
                      {name}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            ) : (
              <Form.Item label="Project Name">
                <Input value={projectName} onChange={this._handleInputChange("projectName")} />
              </Form.Item>
            )}
            <Form.Item label="Portfolio Name">
              <Input value={name} onChange={this._handleInputChange("name")} />
            </Form.Item>
            <Form.Item label="Query">
              {Object.keys(this.props.filter).map(k => {
                const valueText = `${this.props.filter[k]}`;
                return (
                  <Tag key={k}>
                    <strong>{`${k}: `}</strong>
                    {valueText.length > 50 ? `${valueText.substring(0, 50)}...` : valueText}
                  </Tag>
                );
              })}
            </Form.Item>
          </Form>
        </Modal>
      </Fragment>)
    );
  }

  _showConfirm = () => {
    if (this._isMounted)
      this.setState({
        confirmVisible: true
      });
  };

  _hideConfirm = () => {
    if (this._isMounted)
      this.setState({
        confirmVisible: false
      });
  };

  _handleInputChange = k => e => {
    if (this._isMounted)
      this.setState({
        [k]: e.target.value
      });
  };

  _getAllProjects = () => {
    const userId = this.props.user.profile.user_id;
    return getProjects(userId).then(projects => {
      if (this._isMounted)
        this.setState({
          projects
        });
    });
  };

  _saveSearchAsPortfolio = () => {
    if (this._isMounted) this.setState({ loading: true });
    const userId = this.props.user.profile.user_id;
    return createQuery({
      query: JSON.stringify(this.props.filter),
      user_id: userId
    })
      .then(q => {
        const p = {
          name: this.state.name,
          query_id: q[0].id
        };
        return this.state.projectId
          ? createPortfolioByProjectId(userId, this.state.projectId, p)
          : createProject(userId, { name: this.state.projectName }).then(({ id }) => createPortfolioByProjectId(userId, id, p));
      })
      .then(() => {
        if (this._isMounted)
          this.setState(
            {
              loading: false
            },
            this._redirectToPortfolioTool
          );
      });
  };

  _redirectToPortfolioTool = () => {
    this.props.router.push("/patents/portfolio");
  };
}

export default withRouter(withUser(SaveAsPortfolio));
